var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useRef, forwardRef } from 'react';
import styled, { css } from 'styled-components';
import { AccountButton } from './AccountButton';
import { AccountMenu } from '../AccountMenu';
import { device } from '../../breakpoints';
import { ScreenSize, useScreenSize } from '../../hooks';
import { useCombinedRefs, useClickOutside } from '../../../../util';
var AccountDropdownContainer = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  @media ", " {\n    width: 50%;\n    height: 48px;\n  }\n\n  ", "\n\n  ", "\n"], ["\n  @media ", " {\n    width: 50%;\n    height: 48px;\n  }\n\n  ", "\n\n  ", "\n"])), device.laptop, function (_a) {
    var isLoggedIn = _a.isLoggedIn;
    return isLoggedIn && css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      @media ", " {\n        display: none;\n      }\n    "], ["\n      @media ", " {\n        display: none;\n      }\n    "])), device.laptop);
}, function (_a) {
    var showClaimsButton = _a.showClaimsButton;
    return !showClaimsButton && css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      @media ", " {\n        width: 100%;\n        align-self: stretch;\n      }\n    "], ["\n      @media ", " {\n        width: 100%;\n        align-self: stretch;\n      }\n    "])), device.laptop);
});
export var AccountDropdown = forwardRef(function (_a, fRef) {
    var _b = _a.isSelected, isSelected = _b === void 0 ? false : _b, _c = _a.isLoggedIn, isLoggedIn = _c === void 0 ? false : _c, _d = _a.showClaimsButton, showClaimsButton = _d === void 0 ? true : _d, itemGroups = _a.itemGroups, email = _a.email, toggleDropdown = _a.toggleDropdown, onClick = _a.onClick, rest = __rest(_a, ["isSelected", "isLoggedIn", "showClaimsButton", "itemGroups", "email", "toggleDropdown", "onClick"]);
    var dropdownRef = useRef(null);
    var combinedRefs = useCombinedRefs(fRef, dropdownRef);
    var screenSize = useScreenSize();
    var onClickHandler = function (e) {
        onClick === null || onClick === void 0 ? void 0 : onClick(e);
        isLoggedIn && toggleDropdown(!isSelected);
    };
    useClickOutside(function () { return toggleDropdown(false); }, dropdownRef);
    return (React.createElement(AccountDropdownContainer, { ref: combinedRefs, showClaimsButton: showClaimsButton, isLoggedIn: isLoggedIn },
        React.createElement(AccountButton, __assign({ showClaimsButton: showClaimsButton, isLoggedIn: isLoggedIn, isSelected: isSelected, screenSize: screenSize, onClick: onClickHandler }, rest)),
        screenSize === ScreenSize.Large && (React.createElement(AccountMenu, { isActive: isSelected, itemGroups: itemGroups, email: email, showClaimsButton: showClaimsButton, toggleDropdown: toggleDropdown }))));
});
var templateObject_1, templateObject_2, templateObject_3;
